import axios from 'axios'
import { apiUrl } from '../config'
import authenticationStore from '../stores/authenticationStore'

export const BoardReportRequest = {
  getBoardReportList: params =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/board-reports`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      params: params,
    }),
  createBoardReport: boardReportInfo =>
    axios({
      method: 'post',
      url: `${apiUrl}/api/v1/board-reports`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: boardReportInfo,
    }),

  updateBoardReport: (code, boardReportInfo) =>
    axios({
      method: 'put',
      url: `${apiUrl}/api/v1/board-reports/update/${code}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: boardReportInfo,
    }),

  deleteBoardReportByCode: code =>
    axios({
      method: 'delete',
      url: `${apiUrl}/api/v1/board-reports/delete/${code}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),

  getBoardReportByCode: code =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/board-reports/${code}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),

  getBoardReportComment: (code, sort) =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/board-reports/${code}/comments`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),

  createBoardReportComment: (code, data) =>
    axios({
      method: 'post',
      url: `${apiUrl}/api/v1/board-reports/${code}/comments`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      data: data,
    }),
  deleteBoardReportComment: (code, comment_id) =>
    axios({
      method: 'delete',
      url: `${apiUrl}/api/v1/board-reports/${code}/comments/${comment_id}`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
    }),
}
